const loginControllers = angular.module('login-controllers.module', [
  'ui.router',
]);

loginControllers.controller('resetPasswordController', function(
  $scope,
  $stateParams,
  userService
) {
  $scope.password = '';

  $scope.submit = function() {
    userService.resetPassword($scope.password, $stateParams.token);
  };
});
